import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { motion } from 'framer-motion';

const ContactInfo = () => {
  const { t } = useTranslation();

  const contactItems = [
    {
      icon: FaEnvelope,
      title: "contact.email",
      content: "kontakt.dabv@gmail.com"
    },
    {
      icon: FaPhone,
      title: "contact.phone",
      content: "+49 159 8475466"
    },
    {
      icon: FaMapMarkerAlt,
      title: "contact.address",
      content: t('contact.addressText')
    },
    {
      icon: FaClock,
      title: "contact.hours",
      content: t('contact.hoursText')
    }
  ];

  return (
    <div className="bg-white p-6 rounded-lg shadow-md h-full">
      <h3 className="text-xl font-semibold mb-6">
        {t('contact.contactInfo')}
      </h3>
      
      <div className="space-y-6">
        {contactItems.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="flex items-start"
          >
            <div className="flex-shrink-0 mt-1 mr-4 text-primary-500">
              <item.icon className="text-xl" />
            </div>
            <div>
              <h4 className="font-medium text-gray-800">{t(item.title)}</h4>
              <p className="text-gray-600">{item.content}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;